import { prop, uniqBy } from 'ramda'

const options = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
  { label: 'Abkhazian', value: 'ab' },
  { label: 'Afar', value: 'aa' },
  { label: 'Afrikaans', value: 'af' },
  { label: 'Akan', value: 'ak' },
  { label: 'Albanian', value: 'sq' },
  { label: 'Amharic', value: 'am' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Aragonese', value: 'an' },
  { label: 'Armenian', value: 'hy' },
  { label: 'Assamese', value: 'as' },
  { label: 'Avaric', value: 'av' },
  { label: 'Azerbaijani', value: 'az' },
  { label: 'Bambara', value: 'bm' },
  { label: 'Bashkir', value: 'ba' },
  { label: 'Basque', value: 'eu' },
  { label: 'Belarusian', value: 'be' },
  { label: 'Bengali (Bangla)', value: 'bn' },
  { label: 'Bihari', value: 'bh' },
  { label: 'Bislama', value: 'bi' },
  { label: 'Bosnian', value: 'bs' },
  { label: 'Breton', value: 'br' },
  { label: 'Bulgarian', value: 'bg' },
  { label: 'Burmese', value: 'my' },
  { label: 'Catalan', value: 'ca' },
  { label: 'Chamorro', value: 'ch' },
  { label: 'Chechen', value: 'ce' },
  { label: 'Chichewa, Chewa, Nyanja', value: 'ny' },
  { label: 'Chinese', value: 'zh' },
  { label: 'Chinese (Simplified)', value: 'zh-Hans' },
  { label: 'Chinese (Traditional)', value: 'zh-Hant' },
  { label: 'Chuvash', value: 'cv' },
  { label: 'Cornish', value: 'kw' },
  { label: 'Corsican', value: 'co' },
  { label: 'Cree', value: 'cr' },
  { label: 'Croatian', value: 'hr' },
  { label: 'Czech', value: 'cs' },
  { label: 'Danish', value: 'da' },
  { label: 'Divehi, Dhivehi, Maldivian', value: 'dv' },
  { label: 'Dutch', value: 'nl' },
  { label: 'Dzongkha', value: 'dz' },

  { label: 'Esperanto', value: 'eo' },
  { label: 'Estonian', value: 'et' },
  { label: 'Ewe', value: 'ee' },
  { label: 'Faroese', value: 'fo' },
  { label: 'Fijian', value: 'fj' },
  { label: 'Finnish', value: 'fi' },
  { label: 'French', value: 'fr' },
  { label: 'Fula, Fulah, Pulaar, Pular', value: 'ff' },
  { label: 'Galician', value: 'gl' },
  { label: 'Gaelic (Scottish)', value: 'gd' },
  { label: 'Gaelic (Manx)', value: 'gv' },
  { label: 'Georgian', value: 'ka' },
  { label: 'German', value: 'de' },
  { label: 'Greek', value: 'el' },
  { label: 'Greenlandic', value: 'kl' },
  { label: 'Guarani', value: 'gn' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Haitian Creole', value: 'ht' },
  { label: 'Hausa', value: 'ha' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Herero', value: 'hz' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Hiri Motu', value: 'ho' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Icelandic', value: 'is' },
  { label: 'Ido', value: 'io' },
  { label: 'Igbo', value: 'ig' },
  { label: 'Indonesian', value: 'id, in' },
  { label: 'Interlingua', value: 'ia' },
  { label: 'Interlingue', value: 'ie' },
  { label: 'Inuktitut', value: 'iu' },
  { label: 'Inupiak', value: 'ik' },
  { label: 'Irish', value: 'ga' },
  { label: 'Italian', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Javanese', value: 'jv' },
  { label: 'Kalaallisut, Greenlandic', value: 'kl' },
  { label: 'Kannada', value: 'kn' },
  { label: 'Kanuri', value: 'kr' },
  { label: 'Kashmiri', value: 'ks' },
  { label: 'Kazakh', value: 'kk' },
  { label: 'Khmer', value: 'km' },
  { label: 'Kikuyu', value: 'ki' },
  { label: 'Kinyarwanda (Rwanda)', value: 'rw' },
  { label: 'Kirundi', value: 'rn' },
  { label: 'Kyrgyz', value: 'ky' },
  { label: 'Komi', value: 'kv' },
  { label: 'Kongo', value: 'kg' },
  { label: 'Korean', value: 'ko' },
  { label: 'Kurdish', value: 'ku' },
  { label: 'Kwanyama', value: 'kj' },
  { label: 'Lao', value: 'lo' },
  { label: 'Latin', value: 'la' },
  { label: 'Latvian (Lettish)', value: 'lv' },
  { label: 'Limburgish ( Limburger)', value: 'li' },
  { label: 'Lingala', value: 'ln' },
  { label: 'Lithuanian', value: 'lt' },
  { label: 'Luga-Katanga', value: 'lu' },
  { label: 'Luganda, Ganda', value: 'lg' },
  { label: 'Luxembourgish', value: 'lb' },
  { label: 'Manx', value: 'gv' },
  { label: 'Macedonian', value: 'mk' },
  { label: 'Malagasy', value: 'mg' },
  { label: 'Malay', value: 'ms' },
  { label: 'Malayalam', value: 'ml' },
  { label: 'Maltese', value: 'mt' },
  { label: 'Maori', value: 'mi' },
  { label: 'Marathi', value: 'mr' },
  { label: 'Marshallese', value: 'mh' },
  { label: 'Moldavian', value: 'mo' },
  { label: 'Mongolian', value: 'mn' },
  { label: 'Nauru', value: 'na' },
  { label: 'Navajo', value: 'nv' },
  { label: 'Ndonga', value: 'ng' },
  { label: 'Northern Ndebele', value: 'nd' },
  { label: 'Nepali', value: 'ne' },
  { label: 'Norwegian', value: 'no' },
  { label: 'Norwegian bokmål', value: 'nb' },
  { label: 'Norwegian nynorsk', value: 'nn' },
  { label: 'Nuosu', value: 'ii' },
  { label: 'Occitan', value: 'oc' },
  { label: 'Ojibwe', value: 'oj' },
  { label: 'Old Church Slavonic, Old Bulgarian', value: 'cu' },
  { label: 'Oriya', value: 'or' },
  { label: 'Oromo (Afaan Oromo)', value: 'om' },
  { label: 'Ossetian', value: 'os' },
  { label: 'Pāli', value: 'pi' },
  { label: 'Pashto, Pushto', value: 'ps' },
  { label: 'Persian (Farsi)', value: 'fa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Punjabi (Eastern)', value: 'pa' },
  { label: 'Quechua', value: 'qu' },
  { label: 'Romansh', value: 'rm' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Sami', value: 'se' },
  { label: 'Samoan', value: 'sm' },
  { label: 'Sango', value: 'sg' },
  { label: 'Sanskrit', value: 'sa' },
  { label: 'Serbian', value: 'sr' },
  { label: 'Serbo-Croatian', value: 'sh' },
  { label: 'Sesotho', value: 'st' },
  { label: 'Setswana', value: 'tn' },
  { label: 'Shona', value: 'sn' },
  { label: 'Sichuan Yi', value: 'ii' },
  { label: 'Sindhi', value: 'sd' },
  { label: 'Sinhalese', value: 'si' },
  { label: 'Siswati', value: 'ss' },
  { label: 'Slovak', value: 'sk' },
  { label: 'Slovenian', value: 'sl' },
  { label: 'Somali', value: 'so' },
  { label: 'Southern Ndebele', value: 'nr' },

  { label: 'Sundanese', value: 'su' },
  { label: 'Swahili (Kiswahili)', value: 'sw' },
  { label: 'Swati', value: 'ss' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Tagalog', value: 'tl' },
  { label: 'Tahitian', value: 'ty' },
  { label: 'Tajik', value: 'tg' },
  { label: 'Tamil', value: 'ta' },
  { label: 'Tatar', value: 'tt' },
  { label: 'Telugu', value: 'te' },
  { label: 'Thai', value: 'th' },
  { label: 'Tibetan', value: 'bo' },
  { label: 'Tigrinya', value: 'ti' },
  { label: 'Tonga', value: 'to' },
  { label: 'Tsonga', value: 'ts' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Turkmen', value: 'tk' },
  { label: 'Twi', value: 'tw' },
  { label: 'Uyghur', value: 'ug' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Uzbek', value: 'uz' },
  { label: 'Venda', value: 've' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Volapük', value: 'vo' },
  { label: 'Wallon', value: 'wa' },
  { label: 'Welsh', value: 'cy' },
  { label: 'Wolof', value: 'wo' },
  { label: 'Western Frisian', value: 'fy' },
  { label: 'Xhosa', value: 'xh' },
  { label: 'Yiddish', value: 'yi, ji' },
  { label: 'Yoruba', value: 'yo' },
  { label: 'Zhuang, Chuang', value: 'za' },
  { label: 'Zulu', value: 'zu' },
]

export default uniqBy(prop('value'), options)
